var map = {
	"./Diatom (1).jpg": 2437,
	"./Diatom (2).jpg": 822,
	"./Diatom (4).jpg": 8468,
	"./Diatom (5).jpg": 4701,
	"./Diatom_20.jpg": 1918,
	"./Diatom_new sample_03 (2).jpg": 4420,
	"./Diatom_new sample_06 (1).jpg": 413,
	"./Diatom_new sample_06 (2).jpg": 989,
	"./Diatom_new sample_07.jpg": 5522,
	"./Diatom_new sample_08.jpg": 7783,
	"./Diatom_new sample_18 (1).jpg": 1832,
	"./Diatom_new sample_18 (2).jpg": 6857,
	"./Diatom_new sample_18 (3).jpg": 8960,
	"./Diatom_new sample_18 (5).jpg": 972,
	"./Diatoms__coscinodiscus_02.jpg": 3200,
	"./Diatoms_coscinodiscus_01.jpg": 7505,
	"./Diatoms_coscinodiscus_03.jpg": 818
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8072;